import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function strength(pw) {
  if (!pw) return null;
  if (pw.length < 8) return { lvl: 0, text: "For kort – mindst 8 tegn" };
  const score = [pw.length >= 12, /[a-zæøå]/.test(pw) && /[A-ZÆØÅ]/.test(pw), /\d/.test(pw), /[^A-Za-z0-9æøåÆØÅ]/.test(pw)].filter(Boolean).length;
  return score >= 3 ? { lvl: 3, text: "Stærk adgangskode" } : score >= 1 ? { lvl: 2, text: "OK – længere eller med tal/tegn er stærkere" } : { lvl: 1, text: "Svag – tilføj tal, store bogstaver eller tegn" };
}

export function StrengthHint({ pw, testid }) {
  const s = strength(pw);
  if (!s) return <div className="hint">Mindst 8 tegn.</div>;
  return (
    <div className={`pw-meter l${s.lvl}`} data-testid={testid}>
      <span className="pw-bars"><i /><i /><i /></span>
      <span>{s.text}</span>
    </div>
  );
}

export default function PasswordInput({ id, value, onChange, autoComplete, testid, minLength }) {
  const [show, setShow] = useState(false);
  return (
    <div className="pw-wrap">
      <input id={id} type={show ? "text" : "password"} required minLength={minLength} value={value} onChange={onChange}
        autoComplete={autoComplete} data-testid={testid} />
      <button type="button" className="pw-eye" onClick={() => setShow((s) => !s)} aria-label={show ? "Skjul adgangskode" : "Vis adgangskode"}
        aria-pressed={show} data-testid={`${testid}-toggle`}>
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
